import PropTypes from 'prop-types';
import { DateTimePicker } from '@mui/x-date-pickers';
import withErrorHelperText from '../withErrorHelperText';

function DateTimePickerInput(props) {
  const { error, touched, ...otherProps } = props;
  return withErrorHelperText(DateTimePicker, {
    error,
    touched,
  })({
    ...otherProps,
    error: !!error && touched,
  });
}
DateTimePickerInput.defaultProps = {
  error: '',
  touched: false,
};
DateTimePickerInput.propTypes = {
  error: PropTypes.string,
  touched: PropTypes.bool,
};

export default DateTimePickerInput;
